// #region imports
import { useEffect, useState, useRef } from 'react';
import {
    Typography,
    Tooltip,
    TypographyProps
} from '@material-ui/core';
import { Theme, withStyles } from '@material-ui/core/styles';

// #endregion
interface Props extends TypographyProps {
    title: string;
    hoverTitle?: string;
}
const LightTooltip = withStyles((theme: Theme) => ({
    arrow: {
        color: theme.palette.common.white,
        '&::before': {
            border: '1px solid #e2dbdb'
        }
    },
    popper: {
        zIndex: 0
    },
    tooltip: {
        margin: '5px 0px !important',
        backgroundColor: theme.palette.common.white,
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: theme.shadows[1],
        fontSize: theme.typography.pxToRem(12),
        padding: '8px'
        // height: '200px',
        // overflowY: 'scroll',
        // '&::-webkit-scrollbar': {
        //     width: '0.4em'
        // },
        // '&::-webkit-scrollbar-track': {
        //     background: '#f1f1f1'
        // },
        // '&::-webkit-scrollbar-thumb': {
        //     background: '#888',
        //     // outline: '1px solid slategrey'
        // }
    }
}))(Tooltip);
const TypographyField = ({ title, hoverTitle, ...props }: Props) => {
    const [hoverStatus, setHover] = useState(false);
    const textElementRef = useRef(null);
    const toolTipTitle = title !== null ? title : '';
    const compareSize = () => {
        const compare = textElementRef.current && textElementRef.current.scrollWidth > textElementRef.current.clientWidth;
        setHover(compare);
    };
    useEffect(() => {
        compareSize();
        window.addEventListener('resize', compareSize);
      
        return () => {
          window.removeEventListener('resize', compareSize); // Cleanup function
        };
    }, [title]);
    return (
        <>
            <LightTooltip
                arrow
                disableHoverListener={!hoverStatus}
                title={hoverTitle !== undefined ? hoverTitle : toolTipTitle}>
                <Typography
                    ref={textElementRef}
                    {...props}
                    noWrap
                >
                    {title}
                </Typography>
            </LightTooltip>
        </>
    );
};

export default TypographyField;
